import { render, staticRenderFns } from "./ErrorBanner.vue?vue&type=template&id=0cf04f38&"
import script from "./ErrorBanner.vue?vue&type=script&lang=js&"
export * from "./ErrorBanner.vue?vue&type=script&lang=js&"
import style0 from "./ErrorBanner.vue?vue&type=style&index=0&id=0cf04f38&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports